import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getFacilityOnboardingSteps } from "src/api/facility";
import { useCallback, useMemo } from "react";

export function useOnboardingSteps(workplaceId?: string, workplaceUserId?: string) {
  const queryKey = useMemo(() => ["facility-onboarding-steps", workplaceId], [workplaceId]);
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => {
      if (!workplaceId || !workplaceUserId) {
        return undefined;
      }

      return getFacilityOnboardingSteps(workplaceId, workplaceUserId);
    },
    enabled: !!(workplaceId && workplaceUserId),
  });

  const invalidateCache = useCallback(() => {
    void queryClient.invalidateQueries(queryKey);
  }, [queryClient, queryKey]);

  return { data, isLoading, invalidateCache };
}
